import {queries} from '@/shared/integrations/zero'
import {useQuery} from '@rocicorp/zero/react'

export function useGetProtocolActivities(id: string | undefined) {
  return useQuery(queries.protocols.getProtocolActivitiesById(id || ''))
}
